import React from 'react';
import { GoogleMap, Marker, Circle } from '@react-google-maps/api';
import { useState } from 'react';
export const MapGeoFence = ({mapRef, mapContainerStyle, lat, lng, onCircleChange, radius, defaultCenter, onMapClick}) => {
  // const mapStyles = {
  //   height: '400px',
  //   width: '100%',
  // };
  // const [lat, setLat] = useState(props.lat || 0);
  // const [lng, setLng] = useState(props.lng || 0);
  // const [radius, setRadius] = useState(props.radius || 1000);
  // const center = { lat, lng };

  const optionsRedCircle = {
    strokeColor: '#FF0000',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: '#FF0000',
    fillOpacity: 0.0, // Adjusted to make the circle visible
  };

  return (
    <>
      <h2>GeoFence</h2>
      <GoogleMap ref={mapRef}
        mapContainerStyle={mapContainerStyle}
        zoom={13}
        center={defaultCenter}
        onClick={onMapClick}
      >
          {lat && lng && (
            <Marker
              position={defaultCenter}
              draggable={true}
              onDragEnd={onMapClick}
              title="center"
            />
          )}

        {/* Circles  commented out due to bug not moving circle when pin moved.*/}
        {/* <Circle
          center={defaultCenter}
          radius={radius}
          options={optionsRedCircle}
          onRadiusChanged={onCircleChange}
        /> */}
      </GoogleMap>
    </>
  );
};

const MapWithCircles = ({ lat, lng, radius1, radius2 }) => {
  const mapStyles = {
    height: '400px',
    width: '100%',
  };

  const center = { lat, lng };

  const optionsYellowCircle = {
    strokeColor: '#FFFF00',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: '#FFFF00',
    fillOpacity: 0.0, // Adjusted to make the circle visible
  };

  const optionsRedCircle = {
    strokeColor: '#FF0000',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: '#FF0000',
    fillOpacity: 0.0, // Adjusted to make the circle visible
  };

  return (
    <>
      <h2>Geolocation</h2>
      <GoogleMap
        mapContainerStyle={mapStyles}
        zoom={13}
        center={center}
      >
        {/* Marker */}
        <Marker position={center} title="Location" />

        {/* Circles */}
        <Circle
          center={center}
          radius={radius1}
          options={optionsYellowCircle}
        />
        <Circle
          center={center}
          radius={radius2}
          options={optionsRedCircle}
        />
      </GoogleMap>
    </>
  );
};

export default MapWithCircles;